import type { DataFetch } from '../../lib/DataFetch';
import type { ServiceNowAdapter } from '../ServiceNowAdapter';
import type { SNSaveLogOptions } from '../ServiceNowAdapter.interface';

export abstract class BaseLog {
    protected adapter: ServiceNowAdapter;
    protected dataFetch: DataFetch;
    constructor(adapter: ServiceNowAdapter, dataFetch: DataFetch) {
        this.adapter = adapter;
        this.dataFetch = dataFetch;
    }

    abstract saveLog(params: SNSaveLogOptions): void;

    abstract viewLog(sys_id: string): void;

    abstract getLogByCallIds(ids: string[]): Promise<any>;
}
